module.exports = __webpack_public_path__ + "../resources/img/img_visual03.ef3628f9.jpg";